import { render, staticRenderFns } from "./webFoot.vue?vue&type=template&id=b5315a8e&scoped=true"
import script from "./webFoot.vue?vue&type=script&lang=ts"
export * from "./webFoot.vue?vue&type=script&lang=ts"
import style0 from "./webFoot.vue?vue&type=style&index=0&id=b5315a8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5315a8e",
  null
  
)

export default component.exports